/* Shared paged motion for catalogue sections and individual card media. */
(() => {
  if (window.ArnavCarousel) return;
  const bound = new WeakSet();
  function move(track, requested, { loop = true } = {}) {
    const total = track.children.length;
    if (!total) return 0;
    const index = loop ? ((requested % total) + total) % total : Math.max(0, Math.min(requested, total - 1));
    track.dataset.currentSlide = String(index);
    track.style.transform = `translateX(-${index * 100}%)`;
    [...track.children].forEach((slide, position) => {
      slide.setAttribute('aria-hidden', String(position !== index));
      slide.inert = position !== index;
    });
    return index;
  }
  function init(root = document) {
    root.querySelectorAll('[data-arnav-carousel]').forEach(carousel => {
      if (bound.has(carousel)) return;
      bound.add(carousel);
      const track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;
      const previous = carousel.querySelector('[data-carousel-previous]');
      const next = carousel.querySelector('[data-carousel-next]');
      const update = index => {
        const active = move(track, index);
        previous?.classList.toggle('is-disabled', active === 0);
        next?.classList.toggle('is-disabled', active === track.children.length - 1);
      };
      previous?.addEventListener('click', () => update(Number(track.dataset.currentSlide || 0) - 1));
      next?.addEventListener('click', () => update(Number(track.dataset.currentSlide || 0) + 1));
      update(0);
    });
  }
  window.ArnavCarousel = { move, init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
